'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFormatPaint = function MdFormatPaint(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 6.6h5v13.4h-13.4v15c0 0.9-0.7 1.6-1.6 1.6h-3.4c-0.9 0-1.6-0.7-1.6-1.6v-18.4h16.6v-6.6h-1.6v1.6c0 1-0.7 1.8-1.6 1.8h-20c-1 0-1.8-0.8-1.8-1.8v-6.6c0-0.9 0.8-1.6 1.8-1.6h20c0.9 0 1.6 0.7 1.6 1.6v1.6z' })
        )
    );
};

exports.default = MdFormatPaint;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/format-paint.js
// module id = 1046
// module chunks = 36573943044255 79611799117203 213534597649335